import i18n from '../i18n/i18n'

export default {
  methods: {
    getConst (locale, str) {
      return i18n(locale, str)
    }
  },
  computed: {
    locale () {
      return this.$store.getters['geolocation/country']
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/library/mixins/library.js